import { createGlobalStyle } from 'styled-components/macro'
import { theme } from 'styles/theme'

export const Theme = createGlobalStyle`
:root {
  --theme-color: ${theme.colors.accent.buryatiya()} !important;
  --links-color: ${theme.colors.accent.buryatiya(0.55)} !important;
  --music-link-color: ${theme.colors.accent.buryatiya(0.8)} !important;
}
`
